<template>
    <!--优惠券-->
    <div id="mycoupon">
      <person-head :title="title"></person-head>
      <ul>
        <li v-for="(item, index) in couponData" :key="index">
          <!--未使用-->
          <div class="main" v-if="item.status === 0">
            <div class="left active">
              <h4>￥<b>{{parseInt(item.money)}}</b></h4>
              <p>{{item.label}}</p>
            </div>
            <div class="right">
              <h4><span class="tag active">{{item.type}}</span>{{item.name}}</h4>
              <div class="date">
                <p>
                  截止日期：{{item.time}}
                </p>
                <router-link :to="{name: 'CouponClassList', query: {vouchers_id: item.vouchers_id}}">立即使用</router-link>
              </div>
            </div>
          </div>
          <!--使用中-->
          <div class="main" v-else-if="item.status === 1">
            <div class="left active">
              <h4>￥<b>{{parseInt(item.money)}}</b></h4>
              <p>{{item.label}}</p>
            </div>
            <div class="right">
              <h4><span class="tag active">{{item.type}}</span>{{item.name}}</h4>
              <div class="date">
                <p>
                  截止日期：{{item.time}}
                </p>
                <img :src="require('@/assets/img/ordercoupon_img_using.png')">
              </div>
            </div>
          </div>
          <!--已使用 or 已过期-->
          <div class="main" v-else>
            <div class="left">
              <h4>￥<b>{{parseInt(item.money)}}</b></h4>
              <p>{{item.label}}</p>
            </div>
            <div class="right">
              <h4><span class="tag">{{item.type}}</span>{{item.name}}</h4>
              <div class="date">
                <p>
                  截止日期：{{item.time}}
                </p>
                <img :src="item.status === 2 ? require('@/assets/img/ordercoupon_img_used.png') : require('@/assets/img/ordercoupon_img_overdue.png')">
              </div>
            </div>
          </div>
        </li>
        <!--
        <li class="active">
          <div class="left"><img src="../../assets/img/ordercoupon_img_pic1.png" alt=""></div>
          <div class="right">
            <h4><span class="tag">优惠券</span>全程直播班</h4>
            <div class="date">
              <p>
                2018.12.01-2018.12.13
              </p>
              <a href="">立即使用</a>
            </div>
          </div>
        </li>
        <li class="used">
          <div class="left"><img src="../../assets/img/ordercoupon_img_pic1.png" alt=""></div>
          <div class="right">
            <h4><span class="tag">优惠券</span>全程直播班</h4>
            <div class="date">
              <p>
                2018.12.01-2018.12.13
              </p>
              <a href="">立即使用</a>
            </div>
          </div>
        </li>
        <li class="overdue">
          <div class="left"><img src="../../assets/img/ordercoupon_img_pic1.png" alt=""></div>
          <div class="right">
            <h4><span class="tag">优惠券</span>全程直播班</h4>
            <div class="date">
              <p>
                2018.12.01-2018.12.13
              </p>
              <a href="">立即使用</a>
            </div>
          </div>
        </li>
        -->
      </ul>
      <div class="bg"></div>
    </div>
</template>

<script>
import personHead from '../share/header/personHead'
export default {
  name: 'MyCoupon',
  data () {
    return {
      couponData: {},
      title: '我的优惠券'
    }
  },
  components: {
    personHead
  },
  mounted () {
    this.getCoupon()
  },
  methods: {
    getCoupon () {
      let data = {
        page: 1,
        length: 100
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_user_all_coupon',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.couponData = res.data.data.info
          } else if (res.data.errcode === -1) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
            this.$router.push({name: 'PwdLogin', query: {backto: 'MyCoupon'}})
          } else {
            console.log(res.data.message)
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>

<style scoped lang="stylus">
#mycoupon
  ul
    width: 6.54rem
    margin: 0 auto
    .main
      position: relative
      display: flex
      justify-content: space-betwen
      align-items: center
      width: 6.54rem
      height: 1.8rem
      margin: .32rem 0 0
      .left
        width: 2.3rem
        height: 1.8rem
        background: url(../../assets/img/ordercoupon_img_bg0.png) no-repeat center
        -webkit-background-size: 100%
        background-size: 100%
        &.active
          background-image: url(../../assets/img/ordercoupon_img_bg1.png)
        h4
          line-height: .7rem
          margin-top: .4rem
          font-size: .36rem
          color: #fff
          text-align: center
          b
            font-size: .78rem
            color: #fff
        p
          overflow: hidden
          white-space: nowrap
          font-size: .24rem
          color: #fff
          text-align: center
      .right
        width: 4.24rem
        height: 1.8rem
        padding: 0 .12rem
        background-color: #fff
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        h4
          margin: .18rem 0
          font-size: .24rem
          color: #333
          text-align: left
          span.tag
            position: relative
            top: -.02rem
            display: inline-block
            width: .88rem
            height: .28rem
            line-height: .28rem
            // background:linear-gradient(90deg,rgba(122,209,255,1) 0%,rgba(43,183,255,1) 100%)
            background-color: #ccc
            margin-right: .1rem
            font-size: .18rem
            color: #fff
            white-space: nowrap
            text-align: center
            -webkit-border-radius: .14rem
            -moz-border-radius: .14rem
            border-radius: .14rem
            &.active
              background-color: #2BB7FF
        .date
          display: flex
          justify-content: space-between
          align-items: center
          width: 100%
          height: .56rem
          border-bottom: .02rem dashed #E6E6E6
          margin: .46rem auto 0
          p
            font-size: .18rem
            color: #666
          a
            display: inline-block
            width: 1.1rem
            height: .4rem
            line-height: .4rem
            border: .02rem solid #2BB7FF
            font-size: .2rem
            color: #333
            text-align: center
            -webkit-border-radius: .2rem
            -moz-border-radius: .2rem
            border-radius: .2rem
          img
            position: relative
            top: -.5rem
            right: .2rem
            width: 1.04rem
            height: 1.04rem
      &.used, &.overdue
        .right h4 span.tag
          background-color: #ccc
        .right .date a
          display: none
        &::after
          content: "已使用"
          position: absolute
          top: .2rem
          right: .2rem
          display: block
          width: 1rem
          height: 1rem
          line-height: 1rem
          border: .02rem solid #ccc
          color: #ccc
          font-size: .3rem
          text-align: center
          -webkit-border-radius: 50%
          -moz-border-radius: 50%
          border-radius: 50%
          -webkit-transform: rotate(-35deg)
          -moz-transform: rotate(-35deg)
          -ms-transform: rotate(-35deg)
          -o-transform: rotate(-35deg)
          transform: rotate(-35deg)
      &.overdue
        &::after
          content: "已过期"
  .bg
    position: fixed
    top: 0
    left: 0
    z-index: -1
    width: 100%
    height: 100%
    background-color: #F7F7F7
</style>



// WEBPACK FOOTER //
// src/components/personal/MyCoupon.vue